<a *ngIf="!videoHtml" [href]="videoUrl" target="_blank">
  {{ videoUrl }}
</a>
<div *ngIf="videoHtml" [innerHTML]="videoHtml | safeHtml"></div>
